import { isMobile } from '../../../utils';

const stickyHeaderInit = () => {
  const header = document.querySelector('.Header');
  const isOrderPage = document.querySelector('.order-page');
  const isPlagckeckPage = document.querySelector('.PlagiarismCheckerPage');
  const navigationCursor = document.querySelector('.Header__nav__arrow');

  if (!header || isOrderPage || isPlagckeckPage) return false;

  const onScrollHandler = () => {
    if (!isMobile()) {
      const headerHeight = header.offsetHeight / 2;
      const topOffset = (window.pageYOffset || document.documentElement.scrollTop)
        - (document.documentElement.clientTop || 0); /* eslint-disable-line */

      if (topOffset > headerHeight) {
        header.classList.add('sticked');
        navigationCursor.style.opacity = 0;
        document.body.style.paddingTop = '60px';
      } else {
        header.classList.remove('sticked');
        document.body.style.paddingTop = 0;
      }
    } else {
      header.classList.remove('sticked');
      document.body.style.paddingTop = 0;
    }
  };

  return window.addEventListener('scroll', onScrollHandler);
};

export default stickyHeaderInit;
